import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadApplicationStatusFailed, loadApplicationStatusSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, LOADING_DELAY } from '../../../configs';

export default function* loadApplicationStatus(action) {
  try {
    const url = `${BACKEND_URL}/resources/applications/status-summary/`;
    yield delay(LOADING_DELAY);
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadApplicationStatusSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadApplicationStatusFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadApplicationStatusFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action, { promiseCanceled: true }));
  }
}
